import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* Auto-generated. Do not edit! */
/* eslint-disable */

const SvgSe = props => /*#__PURE__*/_jsxs("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "rgb(0 0 0 / 60%)",
  ...props,
  children: [/*#__PURE__*/_jsxs("g", {
    clipPath: "url(#a)",
    children: [/*#__PURE__*/_jsx("path", {
      fill: "#0052B4",
      d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12"
    }), /*#__PURE__*/_jsx("path", {
      fill: "#FFDA44",
      d: "M9.39.285a12 12 0 0 0-3.128 1.173v8.976H.103a12 12 0 0 0 0 3.132h6.16v8.976c.97.529 2.02.927 3.127 1.173v-10.15H23.9a12 12 0 0 0 0-3.13H9.389V.284Z"
    })]
  }), /*#__PURE__*/_jsx("defs", {
    children: /*#__PURE__*/_jsx("clipPath", {
      id: "a",
      children: /*#__PURE__*/_jsx("path", {
        fill: "#fff",
        d: "M0 0h24v24H0z"
      })
    })
  })]
});
export default SvgSe;